import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as InvoiceService from 'services/sales/invoice';

export const useInvoiceService = () => {
  const { token } = useSelector((store) => store.user_data);

  const fetchInvoices = async (options = {}) => {
    const { error, payload } = await InvoiceService.read({ ...options, token });
    if (error) {
      return { invoices: [], size: 0, error: 'Unable to fetch invoices at this time.' };
    }

    const {
      data: invoices,
      meta: { size }
    } = payload;
    return { invoices, size, error: null };
  };

  const generateInvoice = async (options = {}) => {
    const { error, payload } = await InvoiceService.generate({ ...options, token });
    if (error) {
      toast.error('Unable to generate invoice at this time.');
      return { location: null };
    }

    toast.success('Invoice generated successfully.');
    return payload;
  };

  return {
    fetchInvoices,
    generateInvoice
  };
};
